import React from 'react';
import PropTypes from 'prop-types';
import { session as exampleSession } from './reviewData';
import '../AIClients/AIClients.css';
import './PracticeReview.css';

// session을 넘기면 실제 면담 결과 화면, 넘기지 않으면 예시 화면으로 표시한다.
export default function ReviewLayout({ feedback = false, session, children }) {
    const example = !session;
    const info = session || exampleSession;
    return <div className="ai-clients-page review-page"><div className="ai-clients-wrap">
        <header className="ai-clients-intro"><span className="ai-kicker">GARAM MIND · PRACTICE REVIEW</span><h1>{feedback ? '한 번의 면담을, 다음의 성장으로.' : '대화를 돌아보고, 한 사람을 이해하기.'}</h1><p>{feedback ? '면담의 강점과 보완할 점을 연결하고 다음 연습을 준비하세요.' : '면담에서 이해한 내용을 사례 개념화 양식으로 차근차근 정리해보세요.'}</p><span className="ai-phase">{feedback ? '종합 피드백' : '사례 개념화'}{example && ' · 예시 화면'}</span></header>
        <ol className="ai-roadmap" aria-label="면담 연습 단계"><li><b>01</b> 내담자 준비</li><li><b>02</b> 면담</li><li aria-current={!feedback ? 'step' : undefined}><b>03</b> 사례 개념화</li><li aria-current={feedback ? 'step' : undefined}><b>04</b> 종합 피드백</li></ol>
        {example && <div className="ai-alert">교육용 더미 데이터로 구성한 예시입니다. 실제 면담 분석이나 공식 MITI 평정 결과가 아니며, 입력 내용은 서버로 전송되지 않습니다.</div>}
        <section className="review-session" aria-label={example ? '예시 면담 정보' : '면담 정보'}><div><span className="ai-kicker">{example ? 'SAMPLE SESSION · 01' : 'YOUR SESSION'}</span><h2>{info.name} <small>{info.profile}</small></h2><p>{info.title}</p></div><dl><div><dt>면담일</dt><dd>{info.date}</dd></div><div><dt>면담 시간</dt><dd>{info.duration}</dd></div><div><dt>면담 관점</dt><dd>{info.model}</dd></div></dl></section>
        {children}
    </div></div>;
}

ReviewLayout.propTypes = {
    feedback: PropTypes.bool,
    session: PropTypes.shape({ name: PropTypes.string, profile: PropTypes.string, title: PropTypes.string, date: PropTypes.string, duration: PropTypes.string, model: PropTypes.string }),
    children: PropTypes.node.isRequired,
};
